function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PathContext from './pathContext';
import HistoryContext from './historyContext';

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  var _super = _createSuper(Switch);

  function Switch(props, context) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _super.call(this, props, context);
    var history = props.history;

    if (history) {
      _this.state = {
        subPath: history.location.pathname.slice(1)
      };
    }

    return _this;
  }

  _createClass(Switch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var history = this.props.history;

      if (history) {
        this.unlisten = history.listen(function (navEvent) {
          _this2.setState({
            subPath: navEvent.location.pathname.slice(1)
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unlisten) this.unlisten();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state;

      var subPath = ((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.subPath) || this.context.subPath;
      var params = this.context.params;
      var children = this.props.children || [];
      if (!Array.isArray(children)) children = [children];
      var match = bestMatch(subPath, children);
      var history = this.props.history;
      var newSuperPath = match ? [this.context.superPath, match.superPath].filter(function (p) {
        return p != '';
      }).join('/') : null;
      var content;
      if (match) content = React.createElement(PathContext.Provider, {
        value: {
          superPath: newSuperPath,
          subPath: match.subPath,
          params: params.concat(match.params)
        }
      }, match.child);else console.warn("No matching Route found for path:\"".concat(subPath, "\""));
      return history ? React.createElement(HistoryContext.Provider, {
        value: history
      }, content) : content || null;
    }
  }]);

  return Switch;
}(React.Component);

Switch.contextType = PathContext;
export default Switch;

function bestMatch(subPath, children) {
  var subPathSegments = subPath.split('/').filter(function (s) {
    return s !== '';
  });
  var superPath = [];
  var previousSegmentMatches = children.map(function (c) {
    return {
      child: c,
      isDefault: c.props.isDefault,
      superPathSegments: (c.props.path || '').split('/').filter(function (s) {
        return s !== '';
      }),
      subPathSegments: subPathSegments,
      params: []
    };
  });
  var matchGroups = [previousSegmentMatches];

  for (var i = 0; i < subPathSegments.length; i++) {
    var segment = subPathSegments[i];
    var softMatch = true;
    var segmentMatches = [];

    var _iterator = _createForOfIteratorHelper(previousSegmentMatches),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        var childSegment = child.superPathSegments[i];
        var match = childSegment === segment;

        if (match) {
          if (softMatch) {
            segmentMatches = [];
            softMatch = false;
          }
        } else if (softMatch && childSegment && childSegment.startsWith(':')) {
          child.params.push({
            name: childSegment.slice(1),
            value: segment
          });
        } else {
          child.invalidSubPath = childSegment ? true : false;
          continue;
        }

        child.superPathSegments[i] = segment;
        child.subPathSegments = subPathSegments.slice(i + 1);
        segmentMatches.push(child);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (segmentMatches.length === 0) break;
    previousSegmentMatches = segmentMatches;
    matchGroups.push(previousSegmentMatches);
  }

  var defaultMatch = null;

  for (var mi = matchGroups.length - 1; mi >= 0; mi--) {
    var previousLevelGroups = matchGroups[mi];
    defaultMatch = previousLevelGroups.find(function (c) {
      return c.isDefault;
    }) || previousLevelGroups.find(function (c) {
      return !c.invalidSubPath;
    });
    if (defaultMatch) break;
  }

  return defaultMatch ? _objectSpread(_objectSpread({}, defaultMatch), {}, {
    superPath: defaultMatch.superPathSegments.join('/'),
    subPath: defaultMatch.subPathSegments.join('/')
  }) : null;
}